// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2TxUT","legacyBtn":"MutateMid_legacyBtn__2X3qG"};